export const CsvUtilHeader = () => {
  return (
    <header className="space-y-2">
      <h1 className="text-4xl font-bold tracking-tight">CSV Analysis</h1>
      <p className="text-muted-foreground">
        Upload your CSV files for quality analysis, cleaning, and database import
      </p>
    </header>
  );
};